import React from 'react';
import { NavLink } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash, FaEye, FaList } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';


import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import Util from '../../../util/Util';
import ApiUiController from '../../../controller/ApiUiController';
import LeadScoreAPI from '../../../api/LeadScoreAPI';
import Display from '../../../util/Display';
import { Badge } from 'react-bootstrap';

class LeadScore extends React.Component {

  constructor(props) {
    super(props);
    this.dists = [];
    this.state = { inApiCall: true };
    this.path = this.props.match.path;
    const model = reactLocalStorage.getObject(Const.Model).lead_score;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount() { if (this.List) LeadScoreAPI.list(this.onReceived, this.onFail); }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = dists => { this.dists = dists; this.setState({ inApiCall: false }); };

  confirmDelete = index => {
    const message = `Are you sure you want to delete to ${this.dists[index].name}`;
    Util.confirmAlert('Delete', message, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      LeadScoreAPI.delete(this.dists[index].id, this.onDelete, this.onFail);
    });
  };
  onDelete = () => {
    Util.showNotification('Successful', 'Deleted successfully.', 'success');
    LeadScoreAPI.list(this.onReceived, this.onFail);
  };

  render() {
    if (!this.List) return null;
    const LeadScoreUI = this.dists.map((dist, _i) => (
      <tr key={`role_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{dist.rule_name}</td>
        <td>{dist.rule_description}</td>
        <td>{Display.ModelLabelValue('user', dist.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(dist.created_date)}</td>
        <td>{Util.serverStringToDisplayDateTime(dist.updated_date)}</td>
        <td className="btnactionflex">
          <NavLink to={`${this.path}/preview/${dist.id}`}>
            <Badge variant="primary" size='sm' className='m-1 p-2 text-white' > <FaList color='#ffffff' /> Details</Badge>
          </NavLink>
          {this.Update &&
            <NavLink to={`${this.path}/${dist.id}`}>
              <Badge variant="warning" size='sm' className='m-1 p-2 text-white' > <FaPencilAlt color='#ffffff' /> Edit</Badge>
            </NavLink>
          }
          {dist.status !== Const.AlwaysActive && this.Delete &&
            <Badge variant="danger" size='sm' onClick={() => this.confirmDelete(_i)} className='m-1 p-2 text-white' > <FaTrash color='#ffffff' /> Delete</Badge>
          }
        </td>
      </tr>
    ));

    return (
      <>
        <div className="sectionlist pt-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 pb-3"> <h3>Lead Scoring Rules</h3> </div>
              <div className="col-md-6 text-right pb-3">
                {this.Add &&
                  <NavLink to={`${this.path}/0`} className="buttons success">
                    + Add Lead Scoring Rule
                  </NavLink>
                }
              </div>
              <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Rule Name</th>
                      <th>Rule Description</th>
                      <th>Created By</th>
                      <th>Created Date</th>
                      <th>Updated By</th>
                      <th>Updated Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.props.inApiCall}>
                      {LeadScoreUI}
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(LeadScore);
